import { createApi } from '@reduxjs/toolkit/query/react';
import {
  CompositionExternalBody,
  CompanyCompositionResponseQuery,
  UsersCompositionResponseQuery,
  CompositionInternalBody,
} from '../companyService';
import { Dispatch } from 'redux';
import { gql } from 'graphql-request';
import { graphqlRequestBaseQuery } from '@rtk-query/graphql-request-base-query';
import { handleErrors } from '../serviceRtkQuery';
import { prepareAuthHeaders } from '../utils/graphqlAuth';

interface CompositionRequest {
  search: string;
  companyId?: string;
}

export const companyCompositionQuery = createApi({
  reducerPath: 'companyServiceApi',
  baseQuery: graphqlRequestBaseQuery({
    url: config.usersServiceUrl,
    requestHeaders: {
      'gql-data-return': 'true',
    },
    prepareHeaders: prepareAuthHeaders,
    customErrors: handleErrors,
  }),
  tagTypes: ['companyComposition', 'userComposition'],
  endpoints: (builder) => ({
    companyComposition: builder.query<CompositionExternalBody, string>({
      query: (companyId) => {
        return {
          document: gql`
            query CompanyComposition($companyId: String) {
              companyComposition(companyId: $companyId) {
                active
                inactive
                pendingInvites
                userCount
              }
            }
          `,
          variables: {
            companyId,
          },
        };
      },
      providesTags: ['companyComposition'],
      transformResponse: (res: CompanyCompositionResponseQuery) => res.companyComposition,
    }),
    usersComposition: builder.query<CompositionInternalBody, CompositionRequest>({
      query: ({ search, companyId }) => {
        return {
          document: gql`
            query User($search: String, $companyId: String) {
              usersComposition(search: $search, companyId: $companyId) {
                active
                inactive
                pendingInvites
                unmatched
                userCount
              }
            }
          `,
          variables: {
            search,
            companyId,
          },
        };
      },
      providesTags: ['userComposition'],
      transformResponse: (res: UsersCompositionResponseQuery) => res.usersComposition,
    }),
  }),
});

export async function invalidateCompanyTags(
  _: unknown,
  { dispatch, queryFulfilled }: { dispatch: Dispatch; queryFulfilled: Promise<unknown> },
  tags: ('userComposition' | 'companyComposition')[],
) {
  try {
    const res = await queryFulfilled;
    if (res) dispatch(companyCompositionQuery.util.invalidateTags(tags));
  } catch (e) {
    console.error(e);
  }
}
export const { useCompanyCompositionQuery, useUsersCompositionQuery } = companyCompositionQuery;
